// import { Component, OnInit,  Input, OnDestroy, EventEmitter, Output, ViewContainerRef } from '@angular/core';
// import { AppService } from '../../../app.service';
// import { FamilyList, SortOptions, ImplementInspectionRowViewModel, SearchImplementInspectionItem } from './search-inspection.model';
// import { MatDialog } from '@angular/material/dialog';import { NotificationsService } from 'angular2-notifications';
// import { FindInspectionService } from '../../inspection/services/find-inspection.service';
// import { Subscription } from 'rxjs/Subscription';
// import { ActivatedRoute, Router, Params } from '@angular/router';
// import { GenericIdName, GETGenericIdName } from '../setup-implement/setup-implement.model';
// import { CustomerSelectItem, EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
// import { FavouriteDialogService } from '../favourite-dialog/favourite-dialog.service';
// import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
// import { AssetSerialSelectionFilter, ComponentTypeSelectionFilter, ImplementSelectionFilter, JobsiteSelectionFilter, ModelSelectionFilter, SerialNOSelectionFilter } from '../favourite-dialog/favourite-dialog-modal';
// import { OrderInspectionBy } from '../../inspection/models/find-inspection.model';
// import { PageEvent } from '@angular/material/paginator';
// import { ToastsManager } from 'ng2-toastr';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { trigger, transition, style, animate } from "@angular/animations";
import { Component, OnInit, OnDestroy, Input, Output,ViewChild ,ElementRef} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import EventEmitter from "events";
import { Subscription } from "rxjs";
import { AppService } from "../../../../../src/app/app.service";
import { OrderInspectionBy } from "../../inspection/models/find-inspection.model";
import { FindInspectionService } from "../../inspection/services/find-inspection.service";
import { ImplementSelectionFilter, JobsiteSelectionFilter, SerialNOSelectionFilter, ModelSelectionFilter, AssetSerialSelectionFilter, ComponentTypeSelectionFilter } from "../favourite-dialog/favourite-dialog-modal";
import { FavouriteDialogService } from "../favourite-dialog/favourite-dialog.service";
import { CustomerSelectItem, EquipmentSelectItem } from "../setup-equipment/setup-equipment.model";
import { GETSetupEquipmentService } from "../setup-equipment/setup-equipment.service";
import { GenericIdName, GETGenericIdName } from "../setup-implement/setup-implement.model";
import { FamilyList, SearchImplementInspectionItem, ImplementInspectionRowViewModel, SortOptions } from "./search-inspection.model";
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
// import { GETDashboardService } from '../dashboard/dashboard.service';

interface Jobsite {

  Id: number;
  Name: string;
}
@Component({
  selector: 'app-search-inspection',
  templateUrl: './search-inspection.component.html',
  styleUrls: ['./search-inspection.component.scss'],
  animations: [
    trigger(
        'enterAnimation', [
            transition(':enter', [
                style({ height: '1px', opacity: 0 }),
                animate('250ms', style({ height: '324px', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: '324px', opacity: 1 }),
                animate('250ms', style({ height: '1px', opacity: 0 }))
            ])
        ]
    ),
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )],
})

export class SearchInspectionComponent implements OnInit, OnDestroy {
  // Page constants
  PAGE_TITLE: string;

      // Drop-down lists
      separatorKeysCodes: number[] = [ENTER, COMMA];
     
      customerList: CustomerSelectItem[] = [];
      filteredCustomers: any[] = [...this.customerList];
      selectedCustomer: number[] = [];
      selectedCustomers:any = [];
       
      @ViewChild('chipInput') chipInput: ElementRef<HTMLInputElement>;

      // Filter customers based on input
      filterCustomers(value: string): void {
        const filterValue = value.toLowerCase();
        this.filteredCustomers = this.customerList.filter(customer =>
          customer.Name.toLowerCase().includes(filterValue) &&
          !this.selectedCustomers.some(c => c.Name === customer.Name)
        );
      }
    
      // Select customer from autocomplete
      selectCustomer(event: any): void {
        const customerName = event.option.value;
        const selectedCustomer = this.customerList.find(c => c.Name === customerName)
    
        if (selectedCustomer && !this.selectedCustomers.some(c => c.Name === selectedCustomer.Name)) {
          this.selectedCustomers.push(selectedCustomer);
           this.selectedCustomer.push(selectedCustomer.Id);
        }
    
        // Clear input
             this.filterCustomers('');
         this.loadFamiliesForCustomer();
        this.loadJobsitesForCustomer();
        this.chipInput.nativeElement.value = '';
        this.filterCustomers('');
      }
    
      // Remove a customer chip
      removeChip(chip: any): void {
        const index = this.selectedCustomers.indexOf(chip);
        if (index >= 0) {
          this.selectedCustomers.splice(index, 1);
          this.selectedCustomer.splice(index, 1);
        }
        this.loadAllFamilyList();
       this.loadJobsitesForCustomer();
        this.filterCustomers('');
      }
    
      
    
     
















      jobsiteList: any = [];
      filteredJobsites: any[] = [];
  selectedJobsites: any[] = [];
  
  @ViewChild('jobsiteInput') jobsiteInput: ElementRef<HTMLInputElement>;

  filterJobsites(value: string): void {
    const filterValue = value.toLowerCase();
    console.log("Filtering job sites with value:", value);

    this.filteredJobsites = this.jobsiteList.filter(jobsite =>
      jobsite.Name.toLowerCase().includes(filterValue)

    );
    console.log("Filtered job sites:", this.filteredJobsites);
  }
  addJobsite(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.trim();
  
    // Validate the input before adding
    const isJobsiteValid = this.selectedJobsites.some(jobsite => jobsite.Name === value);
  
    if (value && isJobsiteValid && !this.selectedJobsites.some(jobsite => jobsite.Name === value)) {
      // Add the valid jobsite
      const newJobsite = this.selectedJobsites.find(jobsite => jobsite.Name === value);
      this.selectedJobsites.push(newJobsite);
      console.log("Added jobsite:", newJobsite);
    } else if (!isJobsiteValid) {
      console.warn("Invalid jobsite:", value);
    }
  
    // Clear the input field
    if (input) {
      input.value = '';
    }
  
    this.filterJobsites(''); // Reset the filter
  }
  removeJobsite(jobsite: Jobsite): void {
    // Find the index of the jobsite in the selectedJobsites array by comparing IDs
    const index = this.selectedJobsites.findIndex(js => js.Id === jobsite.Id);
  
    if (index >= 0) {
      // Remove the jobsite from selectedJobsites
      this.selectedJobsites.splice(index, 1);
  
      // Remove the jobsite's ID from selectedJobsite
      const idIndex = this.selectedJobsite.indexOf(jobsite.Id);
      if (idIndex >= 0) {
        this.selectedJobsite.splice(idIndex, 1);
      }
    }
  }

  selectJobsite(event: MatAutocompleteSelectedEvent): void {
    const selectedJobsite = event.option.value;
    
    if (this.selectedJobsites.findIndex(js => js.Id === selectedJobsite.Id) === -1) {
      
      const Id = event.option.value.Id;
      this.selectedJobsite.push(Id)
      this.selectedJobsites.push({Id: selectedJobsite.Id, Name: selectedJobsite.Name})
    }
    this.loadEquipmentForJobsite();
    this.jobsiteInput.nativeElement.value = '';
    console.log("Selected Jobsites after selection:", this.selectedJobsites);
  }






      equipmentList: any[] = [];
      selectedEquipmentList: any[] = [];

    // Filtered equipment for autocomplete
    filteredEquipmentList: any[] = [];
    addEquipment(event: any): void {
      const input = event.input;
      const value = event.value.trim();

      // Find the matching equipment
      const selectedEquipment = this.equipmentList.find(
          (equipment) =>
              `${equipment.SerialNumber} : ${equipment.UnitNumber}` === value
      );

      if (selectedEquipment && !this.selectedEquipmentList.includes(selectedEquipment)) {
          this.selectedEquipmentList.push(selectedEquipment);
      }

      // Clear the input
      if (input) {
          input.value = '';
      }

      this.filterEquipmentList();
  }

  // Remove a chip
  removeEquipment(chip: any): void {
      const index = this.selectedEquipmentList.indexOf(chip);
      if (index >= 0) {
          this.selectedEquipmentList.splice(index, 1);
          this.selectedEquipment.splice(index,1);
      }
      this.filterEquipmentList();
  }

  // Handle selection from autocomplete
  selectEquipment(event: any): void {
      const selectedEquipment = event.option.value;
      const Id = event.option.value.Id;
      this.selectedEquipment.push(Id)

      if (
          selectedEquipment &&
          !this.selectedEquipmentList.includes(selectedEquipment)
      ) {
          this.selectedEquipmentList.push(selectedEquipment);
      }

      this.filterEquipmentList();
  }

  // Filter equipment list to exclude already selected equipment
  filterEquipmentList(): void {
      this.filteredEquipmentList = this.equipmentList.filter(
          (equipment) =>
              !this.selectedEquipmentList.includes(equipment)
      );
  }
      equipmentList_: EquipmentSelectItem[] = [];
    //  makeList: GenericIdName[] = [];
     // modelList: GenericIdName[] = [];
     selectedModels = [];  // Array to hold selected models
     modelList = [];  // Array to hold all available models
     filteredModels = [];
  //    filterFamilies(value: string): void {
  //     const filterValue = value.toLowerCase();
  //     this.filteredFamilies = this.familyList.filter(family =>
  //       family.Name.toLowerCase().includes(filterValue) && !this.selectedFamilies.includes(family)
  //     );
  //     if(value==""){
  // this.filteredFamilies=  this.familyList;
  //     }
  //   } 

  filterModels(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredModels=this.modelList.filter(model=>model.Name.toLowerCase().includes(filterValue)&&!this.selectedModels.includes(model))
  
  }
  


  
  addModel(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const foundModel = this.modelList.find(model => model.Name.toLowerCase() === value.toLowerCase());
    if (foundModel && !this.selectedModels.includes(foundModel)) {
      this.selectedModels.push({ Name: value });
    }
    event.chipInput!.clear(); 
     this.filterModels('');
  }

  // Remove model from selected list
  removeModel(model: any): void {
    const index = this.selectedModels.indexOf(model);
    if (index >= 0) {
      this.selectedModel.splice(index, 1);
      
      this.selectedModels.splice(index, 1);
 
    }
  }

  // Select a model from the autocomplete dropdown
  @ViewChild('modelInput') modelInput: ElementRef<HTMLInputElement>;
  selectModel(event: MatAutocompleteSelectedEvent): void {
    const model = event.option.value;
    const Id = event.option.value.Id;
    this.selectedModel.push(Id);


    if (!this.selectedModels.some(selectedModel => selectedModel.Name === model.Name)) {
      this.selectedModels.push(model);
    }
    this.modelInput.nativeElement.value = '';
    this.filterModels('');
  }


  




      implementList: GETGenericIdName[] = [];
      implementTypeList: GenericIdName[] = [];
    //  componentTypeList: GenericIdName[] = [];
      componentTypeList = [];

      // Filtered component types based on user input
      filteredComponentTypes = [];
    
      // Selected component types
      selectedComponentTypes = [];
      filterComponentTypes(value: string): void {

        const filterValue = value.toLowerCase();
        this.filteredComponentTypes = this.componentTypeList.filter(compType =>
          compType.toLower().includes(filterValue)
        );
    
      }
    
      // Add component type to selected list when a token (chip) is entered
      addComponentType(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();
    
      // Add the family if valid and not already selected
      const foundComponentType = this.componentTypeList.find(componentType => componentType.Name.toLowerCase() === value.toLowerCase());
      if (foundComponentType && !this.selectedComponentTypes.includes(foundComponentType)) {
        this.selectedComponentTypes.push(foundComponentType);
      }
    
      // Clear the input value
      event.chipInput!.clear();
      this.filterComponentTypes('');
    }
    removeComponentType(compType: { Name: string }): void {
      // Find the index of the selected component type object to remove
      const index = this.selectedComponentTypes.indexOf(compType);
  
      if (index >= 0) {
        // Remove the object from the array
        this.selectedComponentType.splice(index, 1);
        
        this.selectedComponentTypes.splice(index, 1);
      }
    }
  
  
    // Handle component type selection from autocomplete
    selectComponentType(event: any): void {
  
  
      const selected = event.option.value;
      const Id = event.option.value.Id;
      this.selectedComponentType.push(Id);
      if (!this.selectedComponentTypes.includes(selected)) {
        this.selectedComponentTypes.push(selected);
      }
      this.filterComponentTypes(''); // Reset the filter after selection
    } 

      AssetSerialList: GenericIdName[] = [];
      AssetSerialList_: GenericIdName[] = [];
      AssetSerialALTList: GenericIdName[] = [];
      AssetSerialALTList_: GenericIdName[] = [];
      copyimplementList: GETGenericIdName[] = [];
      copyimplementTypeList: GenericIdName[] = [];
      copycomponentTypeList: GenericIdName[] = [];
  
  
      // Search Filters
     // selectedCustomer: number[] = [];
  
  //    filteredCustomers:any = [];
   //   selectedCustomers:any = [];
      selectedJobsite: number[] = []; 
      selectedEquipment: number[] = [];
      selectedMake: number[] = [];
      selectedModel: number[] = [];
      selectedImplement: number[] = [];
      selectedImplementType: number[] = [];
      selectedAssetALT: number[] = [];
      selectedComponentType: number[] = [];
      selectedFamily:number[]=[]
      familyList: any = [];
      selectedFamilies: any[] = [];
      @ViewChild('familychipInput') familychipInput: ElementRef<HTMLInputElement>;

      // Add a family to the chip list
      addFamily(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();
    
        // Add the family name if valid and not already selected
        const foundFamily = this.familyList.find(family => family.Name.toLowerCase() === value.toLowerCase());
        if (foundFamily && !this.selectedFamilies.includes(foundFamily.Name)) {
          this.selectedFamilies.push(foundFamily.Name); // Store the Name for display
        }
    
        // Clear the input value
        event.chipInput!.clear();
        this.filterFamilies('');
      }
    
      // Remove a family from the chip list
      removeFamily(familyName: string): void {
        const index = this.selectedFamilies.indexOf(familyName);
        if (index >= 0) {
          this.selectedFamilies.splice(index, 1);
          this.selectedFamily.splice(index, 1);
          this.filterFamilies('');
        }
      }
    
      // Select a family from autocomplete
      selectFamily(event: any): void {
        const familyName = event.option.value;
        const selectedFamily = this.familyList.find(f => f.Name === familyName);
    
        if (selectedFamily && !this.selectedFamilies.some(f => f.Name === selectedFamily.Name)) {
          this.selectedFamilies.push(selectedFamily); 
          this.selectedFamily.push(selectedFamily.Id);
        }
    
        // Clear input
        this.GetSerialbyModelFamilyMake();
        this.familychipInput.nativeElement.value = '';
        this.filterFamilies('');
      }
    
      // Filter families based on user input
      filterFamilies(value: string): void {
        const filterValue = value.toLowerCase();
    
        this.filteredFamilies = this.familyList.filter(family =>
          family.Name.toLowerCase().includes(filterValue) && !this.selectedFamilies.includes(family.Name)
        );
    
        // Reset filtered families if input is empty
        if (value === '') {
          this.filteredFamilies = [...this.familyList];
        }
      }











      selectedAssetSerial: number[] = [];
              makeList = [];
        filteredMakes = []; 
        selectedMakes = []; 


     
        filterMakes(value: string): void {
          const filterValue = value.toLowerCase();
      
          // Filter logic
          this.filteredMakes = this.makeList.filter(make =>
            make.Name.toLowerCase().includes(filterValue)
          );
         
      
          // Debugging: Check filtered makes after input
          console.log('Filtered Makes:', this.filteredMakes);
        }
     




        // Function to add a make when a chip is manually entered
        addMake(event: MatChipInputEvent): void {
          const input = event.input;
          const value = event.value;
      
          // Add the make only if it exists in the filtered list
          const selectedMake = this.filteredMakes.find(make => make.Name.toLowerCase() === value.toLowerCase());
      
          if (selectedMake && !this.selectedMakes.includes(selectedMake)) {
            this.selectedMakes.push(selectedMake);
          }
      
          // Clear the input value
          if (input) {
            input.value = '';
          }
      
          // Update filtered list after selection
          this.filterMakes('');
        }
      
        // Function to handle selection from the dropdown
        selectMake(event: MatAutocompleteSelectedEvent): void {
          const selectedMake = event.option.value;
      
          if (!this.selectedMakes.some(make => make.Id === selectedMake.Id)) {
            if (this.selectedMake.find(x => x == selectedMake.Id) == null) {
              this.selectedMake.push(selectedMake.Id);
            }
            this.selectedMakes.push(selectedMake.Name);
           
           
      
          }
          this.GetSerialbyModelFamilyMake();
          this.loadModelList();
          
      
      
          this.filterMakes('');
        }
      
        // Function to remove a make from the selected list
        removeMake(make: any): void {
          const index = this.selectedMakes.indexOf(make);
      
          if (index >= 0) {
            this.selectedMake.splice(index, 1);
           
            this.selectedMakes.splice(index, 1);
            this.loadModelList();
            
            
          }
        }
        
        selectedAssetSerials: any[] = [];
        filteredAssetSerials: any[] = [];
        

        filterAssetSerials(value: string) {
          const filterValue = value?.toLowerCase() || '';
          this.filteredAssetSerials = this.AssetSerialList.filter(asset =>
            asset.Name.toLowerCase().includes(filterValue)
          );
        }
      
        // Add a new Asset Serial as a chip
        addAssetSerial(event: any) {
          const value = (event.value || '').trim();
      
          if (value) {
            const matchedAsset = this.AssetSerialList.find(asset => asset.Name.toLowerCase() === value.toLowerCase());
            if (matchedAsset && !this.selectedAssetSerials.includes(matchedAsset)) {
              this.selectedAssetSerials.push(matchedAsset);
            }
          }
      
          // Clear the input field
          event.input.value = '';
        }
      
        // Remove an Asset Serial chip
        removeAssetSerial(asset: any) {
          const index = this.selectedAssetSerials.indexOf(asset);
          if (index >= 0) {
            this.selectedAssetSerials.splice(index, 1);
            this.selectedAssetSerial.splice(index,1);
          }
        }
      
        // Handle selection from autocomplete
        selectAssetSerial(event: any) {
          const selected = event.option.value;
          const Id = event.option.value.Id;
          this.selectedAssetSerial.push(Id)
          if (!this.selectedAssetSerials.includes(selected)) {
            this.selectedAssetSerials.push(selected);
          }
        }














        filteredImplementTypes: any[] = [];
        selectedImplementTypes: any[] = [];
        addImplementType(event: MatChipInputEvent): void {
          // const inputValue = event.input ? event.input.value : '';
      
          const value = (event.value || '').trim();
          if (value && this.filteredImplementTypes.some(c => c.Name.toLowerCase() === value.toLowerCase())
               && !this.selectedImplementTypes.some(c => c.Name.toLowerCase() === value.toLowerCase())) {
              const selectedImplementType = this.filteredImplementTypes.find(c => c.Name.toLowerCase() === value.toLowerCase());
              if (selectedImplementType) {
               this.selectedImplementTypes.push(selectedImplementType);
               //this.filterImplementTypes(selectedImplementType);
               console.log('selectedImplementTypes: ', this.selectedImplementTypes);
             }
           }
          //   // console.log(this.selectedCustomers);
           event.chipInput!.clear();
          this.filterImplementTypes('');
      
         
        }
      
      
        // Filter implement types based on user input
        filterImplementTypes(value: string): void {
          const filterValue = value.toLowerCase();
          this.filteredImplementTypes = this.implementTypeList.filter(impType =>
            impType.Name.toLowerCase().includes(filterValue)
          );
        }
      
        @ViewChild('implementTypeInput') implementTypeInput: any;
        // Select implement type from the autocomplete options
        selectImplementType(event: any): void {
      
          let Id = this.implementList.find(f => f.Name.split(':')[0].trim() == event.option.value.Name).Id;
          
      
          this.selectedImplementTypes.push(event.option.value.Name);
          this.selectedImplementType.push(event.option.value.Id);    
          this.loadComponentTypes() ;
          this.GetAssetSerialSelectedImplements();
        }
        loadComponentTypes() {
          var params: ComponentTypeSelectionFilter = {
            Implements: this.selectedImplementType
          }
          if (this.selectedImplementType.length > 0) {
            this._favouriteDialogService.GetComponentTypesForSelectedImplements(params).subscribe(r => {
              if (r) {
                this.filteredComponentTypes = r;
                
                if (this.filteredComponentTypes.length > 0) {
      
                  this.componentTypeList = this.filteredComponentTypes;//this.familyList.filter(x=>)
                } else {
                  // this.componentTypeList = this._favouriteDialogService.availableFamilyList
                  this.componentTypeList =[];
                }
              }
            });
          } else {
            //this.loadAllFamilyList();
          }
      
          // this._favouriteDialogService.GetComponentTypesForSelectedImplements(params).subscribe(r => {
          //   this.componentTypeList = r;
          // });
        }
      
        // Remove implement type from the selected list
        removeImplementType(implementType: any): void {
          const index = this.selectedImplementTypes.indexOf(implementType);
          if (index >= 0) {
            this.selectedImplementType.splice(index, 1);
           
            this.selectedImplementTypes.splice(index, 1);
          }
        }



      EvalA: boolean = true;
      EvalB: boolean = true;
      EvalC: boolean = true;
      EvalX: boolean = true;
      onEq:boolean=true;
      startDate: Date;
      endDate: Date;
      NoImps:boolean=false;
      showMultiple:boolean=true;
      selectedEquipment_
      selectedEquipmentval
      showMultipleAssetSerial:boolean=true;
      selectedAssetSerial_
      showMultipleAssetAlt:boolean=true;
      selectedAssetALT_
      selectedAssetAltval 
      GET_Auto:number[]=[]
         





  // Search options
  searchParameters: SearchImplementInspectionItem = new SearchImplementInspectionItem();
  // Get from server
  performSearch: boolean = false;
  searchResults: SearchImplementInspectionItem[] = [];
  //onEq:number=3;
  performSearchImp: boolean = false;
  reset:boolean=false;
  showGraphBar:boolean=false;
  showGraphIcon:boolean=false
  @Input() searchParameters_: SearchImplementInspectionItem = new SearchImplementInspectionItem();

  @Output() Reset:EventEmitter<any> = new EventEmitter<any>();
  public pageNumber = 0;
  public inspectionsPerPage = 25;
  public totalResults = 0;
  public implementInspectionResults: ImplementInspectionRowViewModel[] = [];
  public retrievingInspectionResults = true;
  // public checkAwait: boolean = true;

  private subscriptions: Subscription[] = [];
  private lastItemsSearched: SearchImplementInspectionItem;

  checked = false;

  sortOption: SortOptions;
  evalOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Eval);
  dateOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.InspectionDate, true);
  serialOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.SerialNumber);
  uitOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.UnitNumber);
  customerOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Customer);
  jobsiteOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Jobsite);
  makeOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Make);
  familyOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Family);
  modelOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Model);
  examinerOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Examiner);
  
  constructor(private _appService: AppService,
      //private _dashboardService: GETDashboardService,
      public dialog: MatDialog,
     // private notification: ToastsManager,
      private _favouriteDialogService:FavouriteDialogService,
      private _equipmentService: GETSetupEquipmentService,
  public toastr: NotificationsService, 
  private _findInspectionService: FindInspectionService,
  private _notify: NotificationsService,
  private activatedRoute: ActivatedRoute,
  
  private _router: Router,) {
  
  }

  ngOnInit() {
      this._appService.setPageTitle('Search Inspection');
      this.setInitialDates();
      this.loadCustomers();
      this.loadMakes();
      this.LoadAllImplements();
      this.LoadAllImplementTypes();
      this.loadAllFamilyList()
      this.filteredJobsites = this.jobsiteList;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(
      subscription => {
        if (!subscription.closed) subscription.unsubscribe();
      });
  }

  setInitialDates() {
    this.startDate = this.defaultSearchStartDate;
    this.endDate = this.defaultSearchEndDate;
}
   get defaultSearchStartDate(): Date {
        const date = new Date(Date.now());
        date.setMonth(date.getMonth() - 3);
        return date;
    }

    get defaultSearchEndDate(): Date {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        return date;
    }
  
  show:boolean=false
  hidematgroup:boolean=false
  initializeQueryParamterSubscription() {
    this.subscriptions.push(
      this.activatedRoute.queryParams.subscribe(
        params => {
          const pageNumber: number = params['page'];
          const inspectionsPerPage: number = params['display'];
          if (pageNumber != null) {
            this.pageNumber = pageNumber - 1;
          } else {
            this.pageNumber = 0;
          }

          if (inspectionsPerPage != null) {
            this.inspectionsPerPage = inspectionsPerPage;
          } else {
            this.inspectionsPerPage = 25;
          }

          this.loadInspectionResults(this.lastItemsSearched, this.dateOrder);
      })
    );
  }

  public loadInspectionResults(params: SearchImplementInspectionItem, orderby: OrderInspectionBy) {
    this.retrievingInspectionResults = true;
    this.lastItemsSearched = params;
    this.subscriptions.push(this._findInspectionService
      .getImplementInspections(this.pageNumber, this.inspectionsPerPage, params, orderby, this.checked)
      .subscribe(
        results => {
          this.implementInspectionResults = results.implementInspectionResult;
          this.totalResults = results.TotalRecords;
        },
        error => {
          console.log(error);
          this._notify.error('Error', 'Unable to search for Implement inspections. Please contact TrackTreads support if this error continues to happen. ');
        },
        () => {
          this.retrievingInspectionResults = false;
        })
    );
  }

  OpenInspectionPage(equipmentId:number,LastInspectionId:number){
    console.log('/get-interpretation/inspection/'+equipmentId +'/'+LastInspectionId)
   // this._router.navigate(['/get-interpretation/inspection/'+equipmentId +'/'+LastInspectionId ]);
    window.open('/get-interpretation/inspection/' + equipmentId + '/' + LastInspectionId, '_blank')
  }

  openInspection(EquipmentId,InspectionId){
    if (EquipmentId > 0) {
      window.open('/get-interpretation/inspection/' + EquipmentId + '/' + InspectionId, '_blank')
  } else {
      window.open('/get-interpretation/inspection/0/' + InspectionId, '_blank')

  }
  }

  submitSelection() {
this.performSearch = true;
this.performSearchImp=true;
this.hidematgroup=false;
    var params: SearchImplementInspectionItem = {
        customer: this.selectedCustomer,
        jobsite: this.selectedJobsite,
        equipment: this.selectedEquipment,
        make: this.selectedMake,
        model: this.selectedModel,
        implement: this.selectedImplement,
        evalA: this.EvalA,
        evalB: this.EvalB,
        evalC: this.EvalC,
        evalX: this.EvalX,
        onEq:3,
        ImplementTypes:this.selectedImplementType,
        ComponentTypes:this.selectedComponentType,
        family:this.selectedFamily,
        assetSerial:this.selectedAssetSerial,
        startDate:this.startDate,
        endDate:this.endDate
    }

    this.pageNumber = 0; // Reset the page to 0 after a search
    this.updateQueryParams(); // Update the query paramters now that we are setting the page back to 0
    this.loadInspectionResults(params, this.dateOrder);
    
}

onPageEvent(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    this.inspectionsPerPage = event.pageSize;

    this.updateQueryParams();
  }

  loadAllFamilyList(){
    this._favouriteDialogService.getllFamilyList().subscribe(res=>{
      this.familyList =res;
      this.filteredFamilies = res;
    })
  }

  loadCustomers() {
    // this.familyList  = this. _favouriteDialogService.availableFamilyList 
     this._equipmentService.getCustomerList().subscribe(r => {
         this.customerList = r;
         this.filteredCustomers = r; 
        
     });
 }

 loadMakes() {
    this._equipmentService.getMakeList().subscribe(r => {
        this.makeList = r;
        this.filteredMakes = [...this.makeList];
      });
      
    
}

LoadAllImplements(){
    var params: ImplementSelectionFilter = {
        Equipments: [],
        Customers:[],
         Jobsites:[],
      }
    this._favouriteDialogService.GetImplementsAvailable(params).subscribe(r => {
        if (r) {
            this.implementList = r;
            this.copyimplementList = r;
        }
    });
}

LoadAllImplementTypes(){
    var params: ImplementSelectionFilter = {
        Equipments: [],
            Customers:[],
            Jobsites:[],
      }
    this._favouriteDialogService.GetAllImplementTypesAvailable(params).subscribe(r => {
        if (r) {
            this.implementTypeList = r;
            this.copyimplementTypeList =r;
        }
    });
}

     filteredFamilies:GenericIdName[]=[];
      loadFamiliesForCustomer(){
        var params: JobsiteSelectionFilter = {
          Customers: this.selectedCustomer,
        }
        if(this.selectedCustomer.length>0){
          this._favouriteDialogService.GetFamiliesForSelectedCustomers(params).subscribe(r => {
            if (r) {
              this.filteredFamilies = r;
              if (this.filteredFamilies.length>0) {
              
                this.familyList = this.filteredFamilies;//this.familyList.filter(x=>)
              }else{
                this.familyList  = this. _favouriteDialogService.availableFamilyList 
              }
            }
          });
        }else{
          this.loadAllFamilyList();
        }
        
      }

      loadEquipmentForJobsite() {
        if (this.selectedJobsite == null)
            return;
        var params: number[] = this.selectedJobsite;
        this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
            if (r) {
                this.equipmentList = r;
                this.equipmentList_=r
            }
        });
        this.LoadAllImplementTypesForJobsites();
    }

    LoadAllImplementTypesForJobsites(){
        var params: ImplementSelectionFilter = {
                Equipments: [],
                Customers:this.selectedCustomer,
                Jobsites:this.selectedJobsite,
          }
        this._favouriteDialogService.GetAllImplementTypesAvailable(params).subscribe(r => {
            if (r) {
                this.implementTypeList = r;
                this.copyimplementTypeList =r;
            }
        });
    }

  ResetFields(){
      this.hidematgroup=true;
        this.selectedCustomer=[];
        this.selectedCustomers=[];
        this.selectedFamilies=[];
        this.selectedJobsite=[];
        this.selectedJobsites=[];
        this.selectedEquipment=[];
        this.selectedMake=[];
        this.selectedMakes=[];
        this.selectedImplementTypes=[]
        this.selectedModel=[];
        this.selectedImplement=[];
        this.selectedImplementType=[];
        this.selectedComponentType=[];
        this.selectedFamily=[];
        this.selectedEquipment_=''
        this.selectedEquipmentList=[];
        this.selectedEquipment_=null
        this.selectedAssetSerial=[]
        this.selectedAssetSerial_=''
        this.selectedAssetSerials=[];
        this.selectedAssetSerial_=null
        this.selectedAssetALT=[]
        this.selectedAssetALT_=''
        this.selectedAssetALT_=null
        this.showMultiple= true
        this.showMultipleAssetAlt=true
        this.showMultipleAssetSerial=true
        this.selectedComponentTypes=[];
        this.selectedModels=[];
        this.EvalA = true;
        this.EvalB = true;
        this.EvalC = true;
        this.EvalX = true;   
        this.NoImps = false;   
        this.reset=true;
        this.Reset.emit(this.reset);
        this.setInitialDates();
  }

  updateQueryParams() {
    const queryParams: Params = Object.assign({}, this.activatedRoute.snapshot.queryParams);
    queryParams['page'] = this.pageNumber + 1;
    queryParams['display'] = this.inspectionsPerPage;
    this._router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: queryParams
      });
  }

  showGraphsBar(){
      this.showGraphBar=!this.showGraphBar
    }

    loadJobsitesForCustomer() {
        if (this.selectedCustomer == null)
            return;
        this.selectedJobsite = [];
        this.jobsiteList = [];
        this.selectedEquipment = null;
        this.equipmentList = [];
        var params: JobsiteSelectionFilter = {
            Customers: this.selectedCustomer,
          }
        this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
            if (r) {
                this.jobsiteList = r;
                this.filteredJobsites = r;
            }
          });
          this.LoadAllImplementTypesForCustomers();
    }
    
    LoadAllImplementTypesForCustomers(){
        var params: ImplementSelectionFilter = {
            Equipments: [],
                Customers:this.selectedCustomer,
                Jobsites:[],
          }
        this._favouriteDialogService.GetAllImplementTypesAvailable(params).subscribe(r => {
            if (r) {
                this.implementTypeList = r;
                this.copyimplementTypeList =r;
            }
        });
    }
    
    GetSerialbyModelFamilyMake() {
        this.equipmentList = null
        var params: SerialNOSelectionFilter = {
          Families: this.selectedFamily,
          Makes: this.selectedMake,
          Models:this.selectedModel,
          Jobsites:this.selectedJobsite
        }
        this._favouriteDialogService.GetSerialbyModelFamilyMake(params).subscribe(r => {
          if (r) {
            this.equipmentList = r;
            this.equipmentList_=r
            this.filteredEquipmentList=r;

          }
        });
    
    }
  //   loadModelList() {
  //     if(this.selectedMakeUC==null)
  // return;
  //     this.selectedModel=[];
  //     this.modelList = [];
  //     var params: ModelSelectionFilter = {
  //       Families: this.selectedFamily,
  //       Makes: this.selectedMakeUC
  
  
  //     }
  //     this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
  //       if (r) {
  //         this.modelList = r;
  //         this.filteredModels = r;
  
  
  //       }
  //     });

    loadModelList() {
      if(this.selectedMake==null)
        return;
             this.selectedModel=[];
             this.modelList = [];
       // this.modelList = null
        var params: ModelSelectionFilter = {
          Families: this.selectedFamily,
          Makes: this.selectedMake
        }
        this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
          if (r) {
            this.modelList = r;
            this.filteredModels = r;
          }
        });
    
    }
    onComponentTypeSelected(){

    }

    GetAssetAltForSelectedSerial() {
        var params: AssetSerialSelectionFilter = {
            AssetSerial: this.selectedAssetSerial
          }
       this._favouriteDialogService.GetAssetAltForSelectedSerial(params).subscribe(r => {
            this.AssetSerialALTList = r;
            this.AssetSerialALTList_ = r;
        });
    }

    getEvalA() {this.EvalA= !this.EvalA}
    getEvalB() {this.EvalB= !this.EvalB}
    getEvalC() {this.EvalC= !this.EvalC}
    getEvalX() {this.EvalX= !this.EvalX}
    getOnEquipment() {this.onEq= !this.onEq}

    onImplementTypeSelected(){
        console.log("copyimplementList",this.copyimplementList)
        console.log("implementList",this.implementList)
        console.log("selectedImplementType",this.selectedImplementType)
        this.implementList = this.copyimplementList;
        if(this.selectedImplementType.length>0){
           
            let arra_ =[];
            this.selectedImplementType.map(x=>{
                   let value =  this.implementList.find(z=>z.ImplementTypeId == x);
                   if(value!=null)
                   arra_.push(value);

            })

            this.implementList = arra_;
        }else{
            this.implementList = this.copyimplementList;
        }
      
    }

    onSelectAssetSerial_(value) {
        this.selectedAssetSerial=[]
        if(value!=undefined){
            console.log("t", value)
           this.selectedAssetSerial.push(value) 
        }

        var params: AssetSerialSelectionFilter = {
            AssetSerial: this.selectedAssetSerial
          }
       this._favouriteDialogService.GetAssetAltForSelectedSerial(params).subscribe(r => {
            this.AssetSerialALTList = r;
            this.AssetSerialALTList_ = r;
        });
    }

    onSelectEquipment() {
                
        if (this.selectedEquipment != null) {
            this.selectedImplementType=[];
            this.selectedImplement=[];
            this.selectedComponentType=[];
            this.loadImplementsForEquipment();
        }
    }

    onSelectEquipment_(value){
       
        this.selectedEquipment=[]
        if(value!=undefined){
            console.log("t", value)
           this.selectedEquipment.push(value) 
        }
        console.log("tyy", this.selectedEquipment)
        if (this.selectedEquipment != null) {
            this.selectedImplementType=[];
            this.selectedImplement=[];
            this.selectedComponentType=[];
            this.loadImplementsForEquipment();
        }
    }

    // Gets the list of implements that are currently loaded on the selected equipment.
    loadImplementsForEquipment() {
        if(this.selectedEquipment.length>0){
            var params: ImplementSelectionFilter = {
                Equipments: this.selectedEquipment,
                Customers:this.selectedCustomer,
                Jobsites:this.selectedJobsite,
              }
    
              this._favouriteDialogService.GetAllImplementTypesAvailable(params).subscribe(r => {
                if (r) {
                    this.implementTypeList = r;
                }
            });
            this._favouriteDialogService.GetImplementsAvailable(params).subscribe(r => {
                if (r) {
                    this.implementList = r;
                }
            });
        }else{
            this.implementTypeList = this.copyimplementTypeList;
            this.implementList = this.copyimplementList;

        }
        
    }

    changeModelAutoComplete(event){
        const filterValue = event.target.value.toLowerCase();
     
        this.equipmentList = this.equipmentList_.filter(option => option.SerialNumber.toLowerCase().includes(filterValue));
      }

    changeModelAutoCompleteAssetSerial(event){
        const filterValue = event.target.value.toLowerCase();
     
        this.AssetSerialList = this.AssetSerialList_.filter(option => option.Name.toLowerCase().includes(filterValue));
      }

    changeModelAutoCompleteAssetAlt(event){
        const filterValue = event.target.value.toLowerCase();
     
        this.AssetSerialALTList  = this.AssetSerialALTList_.filter(option => option.Name.toLowerCase().includes(filterValue));
      }

      getTitleAssetSerial(Id: number) {
        if(Id != 0 || Id != null){
            return this.AssetSerialList.find(u => u.Id === Id).Name;
        }
        
      }

      getTitleAssetAlt(Id: number) {
        if(Id != 0 || Id != null){
        return this.AssetSerialALTList.find(u => u.Id === Id).Name;
        }
      }

      onSelectAssetAlt_(value){
       
        this.AssetSerialALTList=[]
        if(value!=undefined){
            console.log("t", value)
           this.AssetSerialALTList.push(value) 
        }
      }

      ShowHidefieldAssetSerial(){
        this.selectedAssetSerial=[]
        this.selectedAssetSerial_=''
        this.showMultipleAssetSerial=!this.showMultipleAssetSerial;
        this.GetAssetSerialSelectedImplements();
    }

    GetAssetSerialSelectedImplements() {
        var params: ComponentTypeSelectionFilter = {
            Implements: this.selectedImplementType
          }
       this._favouriteDialogService.GetAssetSerialSelectedImplements(params).subscribe(r => {
            this.AssetSerialList = r;
            this.AssetSerialList_ = r;
            this.filteredAssetSerials=r;
        });
    }

    ShowHidefield(){
        this.selectedEquipment=[]
        this.selectedEquipment_=''
        this.selectedEquipment_=null
        this.selectedEquipment_=""
        this.selectedEquipment_=0      
        this.loadEquipmentForJobsite();
        
        this.showMultiple=!this.showMultiple;
    }

    ShowHidefieldAssetAlt(){
        this.selectedAssetALT=[]
        this.selectedAssetALT_=''
        this.showMultipleAssetAlt=!this.showMultipleAssetAlt;      
    }

    onImplementSelected() {
        var params: ComponentTypeSelectionFilter = {
            Implements: this.selectedImplementType
          }
       this._favouriteDialogService.GetComponentTypesForSelectedImplements(params).subscribe(r => {
            this.componentTypeList = r;
        });
      }

    sortBy(sortOption: string) {
      const selectedOptions = SortOptions[sortOption];
      switch (selectedOptions) {
        case SortOptions.Eval:
          this.evalOrder.selected = !this.evalOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.evalOrder);
          break;
        case SortOptions.InspectionDate:
          this.dateOrder.selected = !this.dateOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.dateOrder);
          break;
        case SortOptions.SerialNumber:
          this.serialOrder.selected = !this.serialOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.serialOrder);
          break;
        case SortOptions.UnitNumber:
          this.uitOrder.selected = !this.uitOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.uitOrder);
          break;
        case SortOptions.Customer:
          this.customerOrder.selected = !this.customerOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.customerOrder);
          break;
        case SortOptions.Jobsite:
          this.jobsiteOrder.selected = !this.jobsiteOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.jobsiteOrder);
          break;
        case SortOptions.Make:
          this.makeOrder.selected = !this.makeOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.makeOrder);
          break;
        case SortOptions.Family:
          this.familyOrder.selected = !this.familyOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.familyOrder);
          break;
        case SortOptions.Model:
          this.modelOrder.selected = !this.modelOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.modelOrder);
          break;
        case SortOptions.Examiner:
          this.examinerOrder.selected = !this.examinerOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.examinerOrder);
          break;
        // case SortOptions.InspectionFlag:
        //   this.InspectionFlag.selected = !this.InspectionFlag.selected;
        //   this.loadInspectionResults(this.lastItemsSearched, this.InspectionFlag);
        //   break;
      }
  
    }

}
